import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import EditCalendarRoundedIcon from '@mui/icons-material/EditCalendarRounded';
import LocationCityRoundedIcon from '@mui/icons-material/LocationCityRounded';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import ShieldRoundedIcon from '@mui/icons-material/ShieldRounded';
import { Button } from '@teuteuf-games/button';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { useTodaysCountry } from '../../providers/TodaysCountryProvider';
import { trackEvent } from '../../utils/analytics';

/**
 * The ways out of the day's summary: the two replayable modes, then the
 * archive and replay, and finally a way back to today's own result.
 */
export const DailyEndActions = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { rounds, navToRound } = useTodaysCountry();

  const goToMode = (mode: string, path: string) => {
    trackEvent('daily_end_play_mode', { mode });
    history.push(path);
  };

  /**
   * /replay carries the same free-vs-premium handling as /archive: premium
   * members land on today's game to replay, everyone else gets the upgrade
   * page. Nothing is reset here.
   */
  const replay = () => {
    trackEvent('daily_end_replay', { mode: 'daily' });
    history.push('/replay');
  };

  /**
   * Back to the daily flag round, where the player's own result is laid out.
   * Only changes which screen is showing — no guesses or stats are touched.
   */
  const showResults = () => {
    trackEvent('daily_end_results', { mode: 'daily' });
    navToRound(rounds[0]);
  };

  return (
    <div className="grid w-full grid-cols-2 gap-3">
      <Button
        buttonStyle="primary"
        label={t('modes.city-flags.play-now')}
        width="w-full"
        leadingIcon={<LocationCityRoundedIcon />}
        onClick={() => goToMode('city-flags', '/city-flags')}
      />
      <Button
        buttonStyle="quaternary"
        label={t('modes.emblems.play-now')}
        width="w-full"
        leadingIcon={<ShieldRoundedIcon />}
        onClick={() => goToMode('emblems', '/emblems')}
      />
      {/* Not premium-gated: /archive already shows the upgrade page itself. */}
      <Button
        buttonStyle="secondary"
        label={t('archive.archive')}
        width="w-full"
        leadingIcon={<EditCalendarRoundedIcon />}
        onClick={() => history.push('/archive')}
      />
      <Button
        buttonStyle="secondary"
        label={t('daily-end.replay')}
        width="w-full"
        leadingIcon={<RefreshRoundedIcon />}
        onClick={replay}
      />

      {/* Full width on its own row: the longer label does not fit a half-width
          cell, and the shared Button truncates rather than wrapping. */}
      <div className="col-span-2">
        <Button
          buttonStyle="secondary"
          label={t('daily-end.results')}
          width="w-full"
          leadingIcon={<ArrowBackRoundedIcon />}
          onClick={showResults}
        />
      </div>
    </div>
  );
};
